import { IVideoInfo, Player } from 'mggp-player';

type GetStreamCallback = (stream: IVideoInfo | null) => void;
export interface IRequestStreamFuncs {
  getVirtualStream: (
    channelId: number,
    virtualId: string,
    callback: GetStreamCallback
  ) => void;
  getStream: (videoId: number, callback: GetStreamCallback) => void;
}

export function getRequestStreamFuncs(player: Player): IRequestStreamFuncs {
  return {
    getVirtualStream: (
      channelId: number,
      virtualId: string,
      callback: GetStreamCallback
    ): void => {
      if (typeof player.config.getVirtualStream === 'function') {
        player.config.getVirtualStream(channelId, virtualId, (apiResponse) =>
          callback(player.config.getStreamFromData(apiResponse))
        );
      } else {
        callback(null);
      }
    },
    getStream: (videoId: number, callback: GetStreamCallback): void => {
      if (typeof player.config.getStream === 'function') {
        player.config.getStream(videoId, (apiResponse) =>
          callback(player.config.getStreamFromData(apiResponse))
        );
      } else {
        callback(null);
      }
    },
  };
}
